import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppConstants } from 'src/app/app.constants';
import { FormService } from 'src/app/services/form.service';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { SesionService } from 'src/app/services/sesion.service';
import { SharedService } from 'src/app/services/shared.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-verify-access',
  templateUrl: './verify-access.component.html',
  styleUrls: ['./verify-access.component.css']
})
export class VerifyAccessComponent implements OnInit {
  form: FormGroup;
  submitted: Boolean = false;
  nombreSistema: String = environment.ENVIRONMENT.NOMBRE_SISTEMA;
  descripcionSistema: String = environment.ENVIRONMENT.DESCRIPCION_SISTEMA;
  usuario: any = {};
  subscription: any;

  constructor(private formService: FormService, private utils: UtilsService, private sharedService: SharedService, private sesionService: SesionService, private alerts: NotificacionesService, private modal: ModalService) {
    this.subscription = this.sharedService.getUserData().subscribe(data => {
      this.usuario = data;
    });
  }

  ngOnInit(): void {
    this.form = this.formService.getVerifyAccessForm(this.usuario);
  }

  send() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    this.modal.mostrarModalCargando();
    this.sesionService.verifyAccess(this.form.value).subscribe(result => {
      this.modal.cerrarModalCargando();
      let data: any = result;
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        data.credenciales = this.form.value;
        data.credenciales.rol = data.rolUsuario;
        this.sesionService.setSesionData(data.credenciales);
        let emitirVotoUrl = this.utils.getLocalStorage('emitirvoto', false);
        let verResultadosUrl = this.utils.getLocalStorage('verresultados', false);
        this.utils.removeLocalStorage('emitirvoto');
        this.utils.removeLocalStorage('verresultados');
        if (this.utils.validarString(emitirVotoUrl))
          this.utils.redirectExternalPath(emitirVotoUrl);
        else if (this.utils.validarString(verResultadosUrl))
          this.utils.redirectExternalPath(verResultadosUrl);
        else
          this.utils.redirectPathWindow(AppConstants.APLICATION_MODULES.INICIO.ruta);
      } else {
        this.alerts.error(this.utils.validarObjeto(data) ? data.mensaje : 'Código no verificado, intente de nuevo', true);
      }
    }, error => {
      this.modal.cerrarModalCargando();
      console.error(error);
      this.alerts.error('No se pudo verificar al usuario, verifique su conexion e intente de nuevo', true);
    });
  }

  regresarLogin(): void {
    this.utils.redirectPathWindow(AppConstants.APLICATION_MODULES.LOGIN.ruta);
  }

}
